import './styles/app.css';
import { JetApp, HashRouter, plugins } from 'webix-jet';
import { devConfig, startDate, endDate } from 'config/config';
import { countries } from 'config/config';
import { perm } from 'config/config';
import { requestPerm } from 'config/config';
/**
 * Main application class extending JetApp.
 * This class initializes the Webix Jet application with the provided configuration.
 */
export default class MyApp extends JetApp {
    /**
     * Constructor for the main application class.
     * @param {Object} config - Configuration object for the application.
     */
    constructor(config) {
        console.log('entro'); // Log entry into the constructor

        /**
         * Function to determine the screen size category.
         * @returns {string} - Returns "wide", "mid", or "small" based on screen width.
         */
        const size = () => {
            const screen = document.body.offsetWidth; // Get the width of the body
            return screen > 1210 ? 'wide' : screen > 1060 ? 'mid' : 'small';
        };

        let theme = ''; // Variable to store the theme
        let cookies = true; // Flag to check if cookies are enabled

        try {
            theme = webix.storage.local.get('bank_app_theme'); // Attempt to get the theme from local storage
        } catch (err) {
            cookies = false; // Set cookies flag to false if an error occurs
            webix.message(
                "You disabled cookies. The language and theme won't be restored after page reloads.",
                'debug',
            ); // Show debug message
        }

        devConfig.classprm(); // Call a method to set up developer configuration

        const defaults = {
            id: APPNAME, // Application ID
            version: VERSION, // Application version
            router: HashRouter, // Router for the application
            debug: !PRODUCTION, // Debug mode based on production flag
            start: '', // Starting view
            theme: theme || '', // Theme, fallback to empty string
            dateFormat: '%j %F, %H:%i', // Date format
            listLength: 50, // Default length for lists
            size: size(), // Determine the size category
            views: {
                // Mapping of views to their respective components
                information: 'customers.information',
                statistics: 'customers.statistics',
                paymenthistory: 'customers.paymenthistory',
                reportscustomer: 'customers.reportscustomer',
                financescustomer: 'customers.financescustomer',
                virtualsoft: 'login',
                doradobet: 'login',
                justbet: 'login',
                ibetsupreme: 'login',
                miravalle: 'login',
                casinopalace: 'login',
                netabet: 'login',
                intercontinental: 'login',
                astonia: 'login',
                ecuabet: 'login',
                winbet: 'login',
                powerbet: 'login',
                tribet: 'login',
                lotosports: 'login',
                hondubet: 'login',
                latinbet: 'login',
                milbets: 'login',
                gangabet: 'login',
                certdoradobet: 'login',
                sivarbet: 'login',
                vsft: 'login',
                ganamex: 'login',
                camanbet: 'login',
                paniplay: 'login',
                masbet: 'login',
                redcasino: 'login',
                ganaplay: 'login',
            },
        };

        super({ ...defaults, ...config }); // Call the parent constructor with merged defaults and config

        let localeConfig = {}; // Configuration for locale settings
        if (cookies) localeConfig.storage = webix.storage.local; // Use local storage if cookies are enabled

        this.use(plugins.Locale, localeConfig); // Use locale plugin with the configuration

        webix.event(window, 'resize', () => {
            // Event listener for window resize
            new ResizeSensor(jQuery('.int-left'), function () {
                devConfig.setDateModal(lang); // Update date modal on resize
            });
            devConfig.setDateModal(lang); // Initial call to set date modal
            const newSize = size(); // Get new size after resize
        });

        const superView = this; // Reference to the current instance
        const lang = this.getService('locale').getLang(); // Get the current language
        console.log(lang); // Log the current language

        this.attachEvent('app:error:resolve', function (err, url) {
            // Event for resolving errors
            webix.delay(() => this.show('/top/dashboard')); // Redirect to dashboard after a delay
        });

        this.attachEvent('app:guard2', function (url, view, nav) {
            // Event for guarding routes
            console.log(view); // Log the current view
            console.log(url); // Log the current URL
            if (url != null) {
                // Check if the URL requires permission
                if (
                    url[0].page != 'virtualsoft' &&
                    url[0].page != 'doradobet' &&
                    url[0].page != 'ibetsupreme' &&
                    url[0].page != 'justbet' &&
                    url[0].page != 'miravalle' &&
                    url[0].page != 'netabet' &&
                    url[0].page != 'casinopalace' &&
                    url[0].page != 'intercontinental' &&
                    url[0].page != 'astonia' &&
                    url[0].page != 'ecuabet' &&
                    url[0].page != 'winbet' &&
                    url[0].page != 'powerbet' &&
                    url[0].page != 'loading' &&
                    url[0].page != 'tribet' &&
                    url[0].page != 'lotosports' &&
                    url[0].page != 'hondubet' &&
                    url[0].page != 'latinbet' &&
                    url[0].page != 'milbets' &&
                    url[0].page != 'gangabet' &&
                    url[0].page != 'certdoradobet' &&
                    url[0].page != 'sivarbet' &&
                    url[0].page != 'vsft' &&
                    url[0].page != 'ganamex' &&
                    url[0].page != 'camanbet' &&
                    url[0].page != 'paniplay' &&
                    url[0].page != 'redcasino' &&
                    url[0].page != 'ganaplay'
                ) {
                    if (perm.length == 0) {
                        nav.redirect = '/loading'; // Redirect to loading if no permissions
                        if (requestPerm == '') {
                            console.log(url); // Log the URL
                            var urlC = '';
                            for (let entry of url) {
                                urlC = urlC + '/' + entry.page; // Build the URL for permission request
                            }
                            devConfig.setReqPerm(urlC); // Set the required permissions
                            nav.redirect = '/loading'; // Redirect to loading
                        }
                    } else {
                        var permb = false; // Flag for permission check
                        for (let entry of url) {
                            if (entry.page != 'top') {
                                if (perm.find((x) => x.id == entry.page)) {
                                    permb = true; // Permission found
                                } else {
                                    for (let entry2 of perm) {
                                        if (entry2.menu != undefined) {
                                            if (entry2.menu.find((x) => x.id == entry.page)) {
                                                permb = true; // Permission found in menu
                                            }
                                        } else if (entry2.data != undefined) {
                                            if (entry2.data.find((x) => x.id == entry.page)) {
                                                permb = true; // Permission found in data
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (!permb) {
                            nav.redirect = '/loading'; // Redirect if no permission
                        }
                    }
                }
            }
        });

        this.attachEvent('app:guard', function (url, view, nav) {
            // Event for guarding routes
            var url2 = url.split(); // Split the URL
            url = url.split('/'); // Split the URL by '/'
            url.splice(0, 1); // Remove the first element
            if (url != null) {
                var body = document.body; // Reference to the body element
                // Check if the URL requires permission
                if (
                    url[0] != 'virtualsoft' &&
                    url[0] != 'doradobet' &&
                    url[0] != 'ibetsupreme' &&
                    url[0] != 'justbet' &&
                    url[0] != 'miravalle' &&
                    url[0] != 'netabet' &&
                    url[0] != 'casinopalace' &&
                    url[0] != 'intercontinental' &&
                    url[0] != 'astonia' &&
                    url[0] &&
                    url[0] != 'ecuabet' &&
                    url[0] &&
                    url[0] != 'winbet' &&
                    url[0] != 'powerbet' &&
                    url[0] != 'loading' &&
                    url[0] != 'tribet' &&
                    url[0] != 'lotosports' &&
                    url[0] != 'hondubet' &&
                    url[0] != 'latinbet' &&
                    url[0] != 'milbets' &&
                    url[0] != 'gangabet' &&
                    url[0] != 'certdoradobet' &&
                    url[0] != 'sivarbet' &&
                    url[0] != 'vsft' &&
                    url[0] != 'ganamex' &&
                    url[0] != 'camanbet' &&
                    url[0] != 'paniplay' &&
                    url[0] != 'redcasino' &&
                    url[0] != 'ganaplay'
                ) {
                    if (url[0] != 'top') {
                        nav.redirect = '/loading'; // Redirect to loading if no permission
                    }
                    if (perm.length == 0) {
                        nav.redirect = '/loading'; // Redirect to loading if no permissions
                        if (requestPerm == '') {
                            var urlC = '';
                            for (let entry of url) {
                                urlC = urlC + '/' + entry; // Build the URL for permission request
                            }
                            devConfig.setReqPerm(urlC); // Set the required permissions
                            nav.redirect = '/loading'; // Redirect to loading
                        }
                    } else {
                        if (url[1] != undefined) {
                            var url2 = url[1].split('?'); // Split the second part of the URL by '?'
                            url[1] = url2[0]; // Keep only the first part
                        }
                        var permb = false; // Flag for permission check
                        for (let entry of url) {
                            if (entry != 'top') {
                                if (perm.find((x) => x.id == entry)) {
                                    permb = true; // Permission found
                                } else {
                                    for (let entry2 of perm) {
                                        if (entry2.menu != undefined) {
                                            if (entry2.menu.find((x) => x.id == entry)) {
                                                permb = true; // Permission found in menu
                                            }
                                        } else if (entry2.data != undefined) {
                                            if (entry2.data.find((x) => x.id == entry)) {
                                                permb = true; // Permission found in data
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (!permb) {
                            nav.redirect = '/loading'; // Redirect if no permission
                        }
                    }
                } else {
                    // Add specific class to body based on the URL
                    if (url[0] == 'virtualsoft') {
                        body.classList.add('virtual');
                    } else {
                        if (url[0] == 'doradobet') {
                            body.classList.add('dorado');
                        } else {
                            if (url[0] == 'justbet') {
                                body.classList.add('justbet');
                            } else {
                                if (url[0] == 'ibetsupreme') {
                                    body.classList.add('guyana');
                                } else {
                                    if (url[0] == 'miravalle') {
                                        body.classList.add('miravalle');
                                    } else {
                                        if (url[0] == 'casinopalace') {
                                            body.classList.add('casinopalace');
                                        } else {
                                            if (url[0] == 'netabet') {
                                                body.classList.add('netabet');
                                            } else {
                                                if (url[0] == 'intercontinental') {
                                                    body.classList.add('intercontinental');
                                                } else {
                                                    if (url[0] == 'astonia') {
                                                        body.classList.add('astonia');
                                                    } else {
                                                        if (url[0] == 'ecuabet') {
                                                            body.classList.add('ecuabet');
                                                        } else {
                                                            if (url[0] == 'winbet') {
                                                                body.classList.add('winbet');
                                                            } else {
                                                                if (url[0] == 'powerbet') {
                                                                    body.classList.add('powerbet');
                                                                } else {
                                                                    if (url[0] == 'tribet') {
                                                                        body.classList.add('tribet');
                                                                    } else {
                                                                        if (url[0] == 'lotosports') {
                                                                            body.classList.add('lotosports');
                                                                        } else {
                                                                            if (url[0] == 'hondubet') {
                                                                                body.classList.add('hondubet');
                                                                            } else {
                                                                                if (url[0] == 'latinbet') {
                                                                                    body.classList.add('latinbet');
                                                                                } else {
                                                                                    if (url[0] == 'milbets') {
                                                                                        body.classList.add('milbets');
                                                                                    } else {
                                                                                        if (url[0] == 'gangabet') {
                                                                                            body.classList.add(
                                                                                                'gangabet',
                                                                                            );
                                                                                        } else {
                                                                                            if (
                                                                                                url[0] ==
                                                                                                'certdoradobet'
                                                                                            ) {
                                                                                                body.classList.add(
                                                                                                    'certdoradobet',
                                                                                                );
                                                                                            } else {
                                                                                                if (
                                                                                                    url[0] == 'sivarbet'
                                                                                                ) {
                                                                                                    body.classList.add(
                                                                                                        'sivarbet',
                                                                                                    );
                                                                                                } else {
                                                                                                    if (
                                                                                                        url[0] == 'vsft'
                                                                                                    ) {
                                                                                                        body.classList.add(
                                                                                                            'vsft',
                                                                                                        );
                                                                                                    } else {
                                                                                                        if (
                                                                                                            url[0] ==
                                                                                                            'ganamex'
                                                                                                        ) {
                                                                                                            body.classList.add(
                                                                                                                'ganamex',
                                                                                                            );
                                                                                                        } else {
                                                                                                            if (
                                                                                                                url[0] ==
                                                                                                                'camanbet'
                                                                                                            ) {
                                                                                                                body.classList.add(
                                                                                                                    'camanbet',
                                                                                                                );
                                                                                                            } else {
                                                                                                                if (
                                                                                                                    url[0] ==
                                                                                                                    'paniplay'
                                                                                                                ) {
                                                                                                                    body.classList.add(
                                                                                                                        'paniplay',
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    if (
                                                                                                                        url[0] ==
                                                                                                                        'redcasino'
                                                                                                                    ) {
                                                                                                                        body.classList.add(
                                                                                                                            'redcasino',
                                                                                                                        );
                                                                                                                    } else {
                                                                                                                        if (
                                                                                                                            url[0] ==
                                                                                                                            'ganaplay'
                                                                                                                        ) {
                                                                                                                            body.classList.add(
                                                                                                                                'ganaplay',
                                                                                                                            );
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });

        this.attachEvent('app:route', function (url) {
            // Event for handling routing
            webix.attachEvent(
                'onBeforeAjax', // Event before AJAX requests
                function (mode, url, data, request, headers, files, promise) {
                    headers['access-control-allow-credentials'] = 'true'; // Allow credentials in headers
                    headers['x-token'] = localStorage.getItem('x-token'); // Set token from local storage
                    request.withCredentials = true; // Enable credentials for the request
                },
            );

            var progressView = null; // Variable to hold the progress view
            webix.attachEvent('onBeforeAjax', function (mode, url, params, xhr) {
                // Event before AJAX requests
                progressView = $$('preloader'); // Get the preloader view
                xhr.onloadstart = function (event) {
                    showProgress(); // Show progress on load start
                };
                xhr.onloadend = function (event) {
                    hideProgres(); // Hide progress on load end
                };
            });

            /**
             * Show loading progress overlay.
             */
            function showProgress() {
                if (progressView != undefined && progressView != null) {
                    webix.extend(progressView, webix.OverlayBox); // Extend progress view with overlay
                    progressView.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show overlay with loading message
                }
            }

            /**
             * Hide loading progress overlay.
             */
            function hideProgres() {
                setTimeout(function () {
                    if (progressView != undefined && progressView != null) {
                        progressView.hideOverlay(); // Hide the overlay
                        progressView = null; // Clear the progress view
                    }
                }, 0);
            }

            /**
             * Get the progress value as a percentage.
             * @param {number} size - Current size.
             * @param {number} total - Total size.
             * @returns {string} - Progress value as a percentage.
             */
            function getProgressValue(size, total) {
                size = size || 0; // Default size to 0
                total = total || 1; // Default total to 1
                return Math.round((size / total) * 100) + '%'; // Return percentage
            }
        });

        this.attachEvent('app:render', function (url) {
            // Event for rendering the application
            var start = moment().subtract(0, 'days'); // Start date
            var end = moment(); // End date

            /**
             * Callback function to set start and end dates.
             * @param {Object} start - Start date.
             * @param {Object} end - End date.
             */
            function cb(start, end) {
                devConfig.setStartDate(start); // Set start date
                devConfig.setEndDate(end); // Set end date
            }

            // Initialize date range picker based on language
            if (lang == 'en') {
                $('.reportrange2 input, .reportrange input').daterangepicker(
                    {
                        startDate: startDate,
                        endDate: endDate,
                        ranges: {
                            Today: [moment(), moment()],
                            Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                            'Last Month': [
                                moment().subtract(1, 'month').startOf('month'),
                                moment().subtract(1, 'month').endOf('month'),
                            ],
                        },
                        locale: {
                            format: 'YYYY-MM-DD',
                            applyLabel: 'Apply',
                            cancelLabel: 'Cancel',
                            customRangeLabel: 'Custom Range',
                            daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                            monthNames: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                            ],
                        },
                    },
                    cb,
                );
            } else {
                if (lang == 'es') {
                    $('.reportrange2 input, .reportrange input').daterangepicker(
                        {
                            startDate: startDate,
                            endDate: endDate,
                            ranges: {
                                Hoy: [moment(), moment()],
                                Ayer: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                                'Este Mes': [moment().startOf('month'), moment().endOf('month')],
                                'Último Mes': [
                                    moment().subtract(1, 'month').startOf('month'),
                                    moment().subtract(1, 'month').endOf('month'),
                                ],
                            },
                            locale: {
                                format: 'YYYY-MM-DD',
                                applyLabel: 'Aplicar',
                                cancelLabel: 'Cancelar',
                                customRangeLabel: 'Rango personalizado',
                                daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                                monthNames: [
                                    'Enero',
                                    'Febrero',
                                    'Marzo',
                                    'Abril',
                                    'Mayo',
                                    'Junio',
                                    'Julio',
                                    'Agosto',
                                    'Septiembre',
                                    'Octubre',
                                    'Noviembre',
                                    'Diciembre',
                                ],
                            },
                        },
                        cb,
                    );
                } else {
                    if (lang == 'pt') {
                        $('.reportrange2 input, .reportrange input').daterangepicker(
                            {
                                startDate: startDate,
                                endDate: endDate,
                                ranges: {
                                    Hoje: [moment(), moment()],
                                    Ontem: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                    'Últimos 7 dias': [moment().subtract(6, 'days'), moment()],
                                    'Últimos 30 dias': [moment().subtract(29, 'days'), moment()],
                                    'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                                    'Último Mês': [
                                        moment().subtract(1, 'month').startOf('month'),
                                        moment().subtract(1, 'month').endOf('month'),
                                    ],
                                },
                                locale: {
                                    format: 'YYYY-MM-DD',
                                    applyLabel: 'Aceitar',
                                    cancelLabel: 'Declinar',
                                    customRangeLabel: 'Campo Customizado',
                                    daysOfWeek: ['Do', 'Se', 'Te', 'Qua', 'Qui', 'Se', 'Sa'],
                                    monthNames: [
                                        'Janeiro',
                                        'Fevereiro',
                                        'Março',
                                        'Abril',
                                        'Maio',
                                        'Junho',
                                        'Julho',
                                        'Agosto',
                                        'Setembro',
                                        'Outubro',
                                        'Novembro',
                                        'Dezembro',
                                    ],
                                },
                            },
                            cb,
                        );
                    }
                }
            }
            cb(start, end); // Call the callback with start and end dates
        });
    }
}

/**
 * Check if the application is not built as a module and initialize it.
 */
if (!BUILD_AS_MODULE) {
    webix.ready(() => {
        if (!webix.env.touch && webix.env.scrollSize && webix.CustomScroll) webix.CustomScroll.init(); // Initialize custom scroll if applicable
        new MyApp().render(); // Render the application
    });
}

// FILE DOCUMENTED
